import messages from "@smartmixin/i18n/dist/translations/de.json";

export default messages;
